import { html } from "../../helpers/stringHTML";
import { resolveResponsive } from "./config";
import { CSS_CLASSES } from "./constants";

const Icons = {
    ChevronLeft: () => html`
        <svg
            class="tip__icon"
            width="11"
            height="24"
            viewBox="0 0 11 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.0498 4.07996L2.52975 10.5999C1.75975 11.3699 1.75975 12.6299 2.52975 13.3999L9.0498 19.9199"
                stroke="currentColor"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    `,
};

export const renderTip = ({ id, text = "", orientation = "left" }) => {
    // ОБЯЗАТЕЛЬНО вычисляем строку перед рендером
    const activeOrientation = resolveResponsive(orientation);

    return html`
        <div ${id ? `id="${id}"` : ""} class="${CSS_CLASSES.TIP}" data-tip-orientation="${activeOrientation}">
            ${Icons.ChevronLeft()}
            <div class="tip__text">${text}</div>
        </div>
    `;
};

export const renderTipsList = (tips = []) => tips.map(renderTip).join("");
